export const SECONDS_PER_DAY = 86_400;

/** Whole days, with anything under a day named as such rather than rounded to 0. */
export function formatDwell(avgSeconds: number | null): string {
  if (avgSeconds === null) return "—";
  const days = Math.round(avgSeconds / SECONDS_PER_DAY);
  return days < 1 ? "<1d" : `${days}d`;
}
